import type { Persistor } from "redux-persist"

/**
 * Resolves once redux-persist has read the stored state back into the store.
 *
 * The router runs its loader at module load, so XMPP can come online before
 * IndexedDB has been read. A room sync started then sees no `chatMeta`, does a
 * full sync, and the late REHYDRATE overwrites what it fetched with the state
 * from the last session — leaving a gap in the history.
 */
export const waitForRehydration = (
  persistor: Persistor | undefined,
): Promise<void> => {
  if (!persistor || persistor.getState().bootstrapped) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const unsubscribe = persistor.subscribe(() => {
      if (persistor.getState().bootstrapped) {
        unsubscribe()
        resolve()
      }
    })
  })
}
